import type { FC } from "react";
import { checkNiceCxoneIntegrationEnabled } from "../../integrations/integrationsSlice.js";
import { useNiceCxoneDetailOutletContext } from "./niceCxoneIntegrationDetailSection.js";
import { RecordingImportsTab } from "./recordingImportsTab.js";

/**
 * The **Failed imports** tab of the NICE CXone detail: the generic
 * recording-imports surface over this company's NICE CXone row.
 */
export const NiceCxoneImportsTab: FC = () => {
  const { integration } = useNiceCxoneDetailOutletContext();
  // While Alpharun has paused the import, the API refuses reprocess and skip
  // (400), so the tab hides the actions.
  return (
    <RecordingImportsTab
      integrationId={integration.id}
      provider={integration.provider}
      isPaused={!checkNiceCxoneIntegrationEnabled(integration)}
      description="Call recordings from NICE CXone that couldn't be imported. Reprocess a recording to try importing it again, or skip it to dismiss it."
    />
  );
};
